import { ResourceWrapper } from "../ResourceWrapper.ts";
import Semantic from "../../../eventer/Semantic.ts";

export interface MultiFeedEntry {
    readonly remotePod: string
    readonly event: ResourceWrapper
}

export function mergeMultiFeedEntries(
    entries: undefined | MultiFeedEntry[],
    newEntries: MultiFeedEntry[]
): MultiFeedEntry[] {

    const map = new Map<string, MultiFeedEntry>();

    // insert all existing events
    if (entries) {
        for (const entry of entries) {
            const key = `${entry.remotePod}::${entry.event.subject}`
            map.set(key, entry)
        }
    }

    // insert/overwrite with new events
    for (const entry of newEntries) {
        const key = `${entry.remotePod}::${entry.event.subject}`
        map.set(key, entry)
    }

    return Array.from(map.values()).sort((a, b) => {
        const aTime = a.event.getMinDate(Semantic.SchemaOrg.Predicates.startDate.uri)?.getTime() ?? 0;
        const bTime = b.event.getMinDate(Semantic.SchemaOrg.Predicates.startDate.uri)?.getTime() ?? 0;
        return aTime - bTime;
    })
}